import React from "react";
import styles from "./ExternalLink.module.css";
import Button from "@mui/material/Button";

const ExternalLink = () => {
  // Funktion für den "Abbrechen"-Button: geht eine Seite in der Browser-Historie zurück
  const handleCancel = () => {
    window.history.back();
  };

  // Funktion für den "Fortfahren"-Button: leitet direkt auf den Instagram-Link weiter
  const handleContinue = () => {
    window.location.href =
      "https://www.instagram.com/weddingcuisine?igsh=emk3M2pyaWI0bHhp";
  };

  return (
    <div className={styles.content}>
      <div className={styles.warningBox}>
        <h2 className={styles.title}>Achtung: Externer Link</h2>

        {/* Hinweis, dass die eigene Website verlassen wird */}
        <p className={styles.text}>Sie verlassen nun unsere Website.</p>

        {/* Hinweis auf die Verantwortung für externe Inhalte */}
        <p className={styles.text}>
          Bitte beachten Sie, dass Sie auf eine externe Internetseite
          weitergeleitet werden. Für die Inhalte und die Datenschutzrichtlinien
          der verlinkten Seite übernehmen wir keine Verantwortung.
        </p>

        {/* Klarstellung der Zuständigkeit */}
        <p className={styles.text}>
          Die Verantwortung liegt beim jeweiligen Anbieter der externen Website.
        </p>

        {/* Buttons zum Abbrechen oder Fortfahren */}
        <div className={styles.buttonContainer}>
          <Button
            fullWidth
            variant="contained"
            onClick={handleContinue}
            sx={{
              backgroundColor: "var(--primary-color)",
              color: "#fff",
              padding: "10px 20px",
              borderRadius: "5px",
              fontWeight: 500,
              textAlign: "center",
              fontSize: "16px",
              border: "none",
              boxShadow: "none",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "var(--primary-color-hover)",
                border: "none",
                boxShadow: "none",
                color: "#fff",
              },
            }}
          >
            Fortfahren
          </Button>
          <Button
            fullWidth
            variant="contained"
            onClick={handleCancel}
            sx={{
              backgroundColor: "var(--primary-color)",
              color: "#fff",
              padding: "10px 20px",
              borderRadius: "5px",
              fontWeight: 500,
              textAlign: "center",
              fontSize: "16px",
              border: "none",
              boxShadow: "none",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "var(--primary-color-hover)",
                border: "none",
                boxShadow: "none",
                color: "#fff",
              },
            }}
          >
            Abbrechen
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ExternalLink;
